import React, { useEffect, useRef, useState } from "react";
import Button from "components/Elements/Button/Button.js";
import useAvoidFirstMount from "hooks/useMountedState.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import FilesCounterTitle from "../Reusable/FilesCounterTitle.js";
import Login from "components/Structure/Login/Login.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useUser } from "contexts/userContext/userContext.js";

const RecipientElement = ({ currentRecipients, setScrolledTop }) => {
  const { getTextByKey } = useContent();

  const recipientEmail = (Array.isArray(currentRecipients) && currentRecipients.length)
    ? currentRecipients[0] +
      (currentRecipients.length > 1 ? ` +${currentRecipients.length - 1}` : "")
    : currentRecipients;
    
  return (typeof currentRecipients?.[0] === 'string') && (
    <div
      className="mobile-recipient-email"
      onClick={() => {
        setScrolledTop(false);
      }}
    >
      {getTextByKey("send-file-to-text")}
      <span>{recipientEmail}</span>
    </div>
  );
};

const MobileUploaderSwapElement = ({ currentRecipients }) => {
  const { getTextByKey } = useContent();
  const { getUploading } = useUploader();
  const { setModal } = useModal();
  const { isLoggedIn } = useUser();
  const [scrolledTop, setScrolledTop] = useState(true);

  useEffect(() => {
    document.querySelector(".mobile-uploader-wrapper").scrollTo({
      top: scrolledTop ? 0 : 3000,
      behavior: "smooth",
    });
  }, [scrolledTop]);

  const prevScrollPos = useRef(0);
  const stopTouchMoveRef = useRef(false);

  const stopTouchMove = (e) => {
    if (stopTouchMoveRef.current) {
      e.preventDefault();
    }
  };

  const touchStartFunc = (e) => {
    stopTouchMoveRef.current = false;
  };

  const detectIfScrolledMoreThanHalf = (e) => {
    const { scrollTop, clientHeight } = e.target;
    const scrolledToBottom = scrollTop >= 150;
    const scrolledToTop = clientHeight - scrollTop >= 150;
    const isScrollingDown = scrollTop > prevScrollPos.current;
    const isScrollingUp = scrollTop < prevScrollPos.current;
    if (scrolledToBottom && isScrollingDown) {
      setScrolledTop(false);
      stopTouchMoveRef.current = true;
    } else if (scrolledToTop && isScrollingUp) {
      setScrolledTop(true);
      stopTouchMoveRef.current = true;
    }
    prevScrollPos.current = scrollTop;
  };

  useEffect(() => {
    const mobileUploaderWrapper = document.querySelector(
      ".mobile-uploader-wrapper"
    );
    if (!mobileUploaderWrapper) return;
    mobileUploaderWrapper.addEventListener(
      "scroll",
      detectIfScrolledMoreThanHalf
    );
    mobileUploaderWrapper.addEventListener("touchmove", stopTouchMove);
    mobileUploaderWrapper.addEventListener("touchstart", touchStartFunc);
    return () => {
      mobileUploaderWrapper.removeEventListener(
        "scroll",
        detectIfScrolledMoreThanHalf
      );
      mobileUploaderWrapper.removeEventListener("touchmove", stopTouchMove);
      mobileUploaderWrapper.removeEventListener("touchstart", touchStartFunc);
    };
  }, []);

  useAvoidFirstMount({
    callback: () => {
      setScrolledTop(getUploading());
      if (getUploading()) {
        document.activeElement.blur();
      }
    },
    dependencies: [getUploading()],
  });

  const handleClick = () => {
    setScrolledTop((prev) => !prev);
  };

  const handleLogin = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setModal({
      modal: Login,
      modalSize: "full-modal",
    });
  };

  return (
    <div className="mobile-uploader-swap-element">
      {scrolledTop ? (
        currentRecipients?.length > 0 ? (
          <RecipientElement
            currentRecipients={currentRecipients}
            setScrolledTop={setScrolledTop}
          />
        ) : null
      ) : (
        <div className="form-swap-view">
          <FilesCounterTitle />
          {!isLoggedIn() ? (
            <div className="call-to-login">
              {getTextByKey("already-have-account-text")}
              <span onClick={handleLogin}>{getTextByKey("login")}</span>
            </div>
          ) : null}
        </div>
      )}
      <div className="flex-spacer"></div>
      {scrolledTop ? (
        <Button onClick={handleClick}>
          {getTextByKey(getUploading() ? "edit-mail-details-uploader" : "next")}
        </Button>
      ) : (
        <Icon onClick={handleClick} name="arrow-up" white />
      )}
    </div>
  );
};
export default MobileUploaderSwapElement;
